import { FC, ReactElement } from "react";

import { no_data_img } from "@/constants";

const NoData: FC = (): ReactElement => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', height: '100%' }}>
      <img src={no_data_img} width="300px" height="300px" alt="no-data" />
    </div>
  );
};

export default NoData;
